import { Link, Image } from '@/components';
import MetaTag from '@/components/ui/MetaTag';
import { PageLayout, PagePath } from '@/layouts/shared';
import withAuthServerSideProps from '@/libs/auth';
import { GetServerSidePropsContext } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

const SupportPage = () => {
  const { t } = useTranslation('layout');

  const pageItems = [
    { path: PagePath.PrivacyPolicyPage, type: 'link', text: t('footer.page.privacy-policy') },
    { path: PagePath.RefundPolicyPage, type: 'link', text: t('footer.page.refund-policy') },
    { path: PagePath.DepositPolicyPage, type: 'link', text: t('footer.page.deposit-policy') },
    { path: PagePath.CustomerLevelInfo, type: 'link', text: t('footer.page.customer-level-info') },
    { path: PagePath.CustomerBenefitPolicyPage, type: 'link', text: t('footer.page.customer-benefit-policy') },
    { path: PagePath.ProductWarrantyPolicyPage, type: 'link', text: t('footer.page.product-warranty-policy') },
    { path: PagePath.PaymentGuidePolicyPage, type: 'link', text: t('footer.page.payment-guide') },
    {
      path: 'https://www.anthu.vn/article/mua-hang-tra-gop-tai-kim-cuong-an-thu/',
      type: 'link',
      text: t('footer.page.payment-installment'),
    },
    { path: PagePath.CheckoutPolicyPage, type: 'link', text: t('footer.page.checkout-policy') },
    {
      path: PagePath.ShippingAndDeliveryPolicyPage,
      type: 'link',
      text: t('footer.page.shipping-and-delivery-policy'),
    },
    {
      path: PagePath.ConsignPolicyPage,
      type: 'link',
      text: t('footer.page.consign-policy')
    },
    {
      path: PagePath.RentalPolicyPage,
      type: 'link',
      text: t('footer.page.rent-policy')
    },
    {
      path: PagePath.MeasuringGuidePage,
      type: 'link',
      text: t('footer.page.measuring-guide')
    }
  ];
  return (
    <>
      <MetaTag title="Hỗ trợ khách hàng" description="Hỗ trợ khách hàng" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-flex-col tw-px-0 lg:tw-px-10 tw-text-base tw-leading-6">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            Hỗ trợ khách hàng
          </h1>

          <div className="tw-grid tw-mt-10 tw-grid-cols-1 md:tw-grid-cols-2 tw-w-full tw-mx-auto  tw-gap-4">
            <div className="md:tw-border-r tw-border-primary-main tw-flex tw-flex-col tw-gap-4">
              {pageItems.slice(0, pageItems.length / 2).map((item, index) => (
                <Link url={item.path} key={`page-link-${index}`} className="tw-flex tw-items-center">
                  <Image src="/diamond.svg" alt="diamond" className="tw-w-6 tw-h-6 tw-mr-2" />
                  <span className="tw-text-black">{item.text}</span>
                </Link>
              ))}
            </div>
            <div className="tw-flex tw-flex-col tw-gap-4 lg:tw-pl-10">
              {pageItems.slice(pageItems.length / 2, pageItems.length).map((item, index) => (
                <Link url={item.path} key={`page-link-${index}`} className="tw-flex tw-items-center">
                  <Image src="/diamond.svg" alt="diamond" className="tw-w-6 tw-h-6 tw-mr-2" />
                  <span className="tw-text-black">{item.text}</span>
                </Link>
              ))}{' '}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.New,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default SupportPage;
